import { isEmpty, pick } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import Layout from "../Layout";

const ChangePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const logoutUser = useContextSelector(AuthContext, (ctx) => ctx.logoutUser);

  const preventMaxInput = (e) => {
    e.target.value = e.target.value.trimStart();
    e.target.value = e.target.value.replace(/  +/g, " ");
  };

  const [showPassword, setShowPassword] = useState({
    first: false,
    second: false,
    third: false,
  });
  const handleShow = (id) => {
    setShowPassword({ ...showPassword, [id]: !showPassword[id] });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    trigger,
    setValue,
  } = useForm({});

  useEffect(() => {
    if (!isEmpty(watch("confirmPassword"))) {
      if (watch("newPassword")) {
        trigger("confirmPassword");
      }
    }
  }, [watch("newPassword")]);

  const onSubmit = async (body) => {
    const obj = pick(body, ["oldPassword", "newPassword"]);
    const { status, data } = await apiPost(apiPath.changePassword, obj);
    if (status === 200) {
      if (data.success) {
        toast.success(data?.message);
        logoutUser();
        navigate("/");
      } else {
        toast.error(data?.message);
      }
    } else {
      toast.error(data?.message);
    }
  };

  return (
    <Layout>
      <div className="change-password-container">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate="novalidate"
          className="v-form mobile"
        >
          <div className="pa-2 col col-12">
            <div className="change-password-wrapper">
              <div className="px-2 change-password-row">
                <div className="no-gutters col-md-3 col">
                  <label className="white__text">{t("Currentpassword")}</label>
                </div>
                <div className="v-input change-password-input theme--light v-text-field v-text-field--is-booted v-text-field--placeholder">
                  <div className="v-input__control">
                    <div className="v-input__slot">
                      <div className="v-text-field__slot">
                        <input
                          id="input-590"
                          placeholder={t("FillUpPasswordHere")}
                          type={showPassword?.first ? "text" : "password"}
                          maxLength={20}
                          minLength={6}
                          onInput={(e) => preventMaxInput(e)}
                          {...register("oldPassword", {
                            required: t("Pleaseentercurrentpassword"),
                            validate: (value) => {
                              if (value === "") return true;
                              if (!!value.trim()) return true;
                              return t("PasswordCannotContainOnlyWhitespace");
                            },
                            pattern: {
                              value: /^[a-zA-Z0-9]+$/,
                              message:
                                t("PasswordCanOnlyContainLettersAndNumbers"),
                            },
                          })}
                        />
                      </div>
                      <div className="v-input__append-inner">
                        <div></div>
                      </div>
                      <div className="v-input__append-inner">
                        <div className="v-input__icon v-input__icon--append">
                          <button
                            type="button"
                            aria-label={t("AppendIcon")}
                            onClick={() => handleShow("first")}
                            className="v-icon notranslate v-icon--link material-icons theme--light"
                          >
                            remove_red_eye
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="v-text-field__details">
                      <div className="v-messages theme--light">
                        <div className="v-messages__wrapper">
                          {errors.oldPassword && errors.oldPassword.message && (
                            <div style={{ marginTop: "3px" }} className="alert">
                              {errors.oldPassword.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="profile-divider"></div>

              <div className="px-2 change-password-row">
                <div className="no-gutters col-md-3 col">
                  <label className="white__text">{t("Password")}</label>
                </div>
                <div className="v-input change-password-input theme--light v-text-field v-text-field--is-booted v-text-field--placeholder">
                  <div className="v-input__control">
                    <div className="v-input__slot">
                      <div className="v-text-field__slot">
                        <input
                          id="input-594"
                          placeholder={t("FillUpPasswordHere")}
                          type={showPassword?.second ? "text" : "password"}
                          maxLength={20}
                          minLength={6}
                          onInput={(e) => preventMaxInput(e)}
                          {...register("newPassword", {
                            required: t("Pleaseenternewpassword"),
                            validate: (value) => {
                              if (value === "") return true;
                              if (!!value.trim()) return true;
                              return t("PasswordCannotContainOnlyWhitespace");
                            },
                            pattern: {
                              value: /^[a-zA-Z0-9]+$/,
                              message:
                                t("PasswordCanOnlyContainLettersAndNumbers"),
                            },
                          })}
                        />
                      </div>
                      <div className="v-input__append-inner">
                        <div></div>
                      </div>
                      <div className="v-input__append-inner">
                        <div className="v-input__icon v-input__icon--append">
                          <button
                            type="button"
                            aria-label={t("AppendIcon")}
                            onClick={() => handleShow("second")}
                            className="v-icon notranslate v-icon--link material-icons theme--light"
                          >
                            remove_red_eye
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="v-text-field__details">
                      <div className="v-messages theme--light">
                        <div className="v-messages__wrapper">
                          {errors.newPassword && errors.newPassword.message && (
                            <div style={{ marginTop: "3px" }} className="alert">
                              {errors.newPassword.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="profile-divider"></div>

              <div className="px-2 change-password-row">
                <div className="no-gutters col-md-3 col">
                  <label className="white__text">{t("Confirmnewpassword")}</label>
                </div>
                <div className="v-input change-password-input theme--light v-text-field v-text-field--is-booted v-text-field--placeholder">
                  <div className="v-input__control">
                    <div className="v-input__slot">
                      <div className="v-text-field__slot">
                        <input
                          id="input-598"
                          placeholder={t("FillUpPasswordHere")}
                          type={showPassword?.third ? "text" : "password"}
                          maxLength={20}
                          minLength={6}
                          onInput={(e) => preventMaxInput(e)}
                          {...register("confirmPassword", {
                            required: {
                              value: true,
                              message: t("Pleaseenterconfirmpassword"),
                            },
                            validate: (value) => {
                              if (value === "") return true;
                              if (!isEmpty(watch("newPassword"))) {
                                if (value === watch("newPassword")) return true;
                                return t("PasswordsDoNotMatch");
                              }
                            },
                          })}
                          onChange={(e) => {
                            setValue("confirmPassword", e.target.value, {
                              shouldValidate: true,
                            });
                          }}
                        />
                      </div>
                      <div className="v-input__append-inner">
                        <div></div>
                      </div>
                      <div className="v-input__append-inner">
                        <div className="v-input__icon v-input__icon--append">
                          <button
                            type="button"
                            aria-label={t("AppendIcon")}
                            onClick={() => handleShow("third")}
                            className="v-icon notranslate v-icon--link material-icons theme--light"
                          >
                            remove_red_eye
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="v-text-field__details">
                      <div className="v-messages theme--light">
                        <div className="v-messages__wrapper">
                          {errors.confirmPassword &&
                            errors.confirmPassword.message && (
                              <div
                                style={{ marginTop: "3px" }}
                                className="alert"
                              >
                                {errors.confirmPassword.message}
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="full-width d-flex justify-center">
                <button
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                  className="change-password-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                >
                  <span className="v-btn__content">{t("Submit")}</span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>{" "}
    </Layout>
  );
};

export default ChangePassword;
